import { ApplicationLog } from '@organization/api/requests'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getApplicationsTableColumns } from './tableColumns'
import {
  LogApplicationsActions,
  LogApplicationsActionsTypes
} from '../LogActions'
import { getApplicationsActionColumnMenu } from './tableActions'

type Props = {
  data?: ApplicationLog[]
  triggerSort: (sorter: SorterResult<ApplicationLog>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<ApplicationLog>
  ) => TableColumnsType<ApplicationLog>
} & TableProps<ApplicationLog>

export const LogApplicationsTable = ({
  data,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const [modal, setModal] = useState<{
    type: LogApplicationsActionsTypes
    data: ApplicationLog
  } | null>(null)

  const columns = getSortedTableColumns(
    getApplicationsTableColumns(getApplicationsActionColumnMenu(setModal, t), t)
  )

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        scroll={{ x: 'auto' }}
        onChange={(_, __, sorter) =>
          triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
        }
        {...props}
      />

      {modal && (
        <LogApplicationsActions
          open
          onCancel={() => setModal(null)}
          onSuccess={() => setModal(null)}
          {...modal}
        />
      )}
    </>
  )
}
